import React, { useEffect, useState } from 'react';
import { Stack,  TextField, InputAdornment, IconButton } from '@mui/material';
import ClearIcon from "@mui/icons-material/Clear";


const SearchBar = ({ searchText, setSearchText }) => {
    return (<Stack sx={{mt:1}}>
        <TextField
            value={searchText}
            onChange={(e)=>{setSearchText(e.target.value)}}
            placeholder='Search'
            slotProps={{
                input: {
                    endAdornment: searchText && (
                        <InputAdornment position="end">
                        <IconButton
                            size="small"
                            edge="end"
                            onClick={() => setSearchText("")}
                        >
                            <ClearIcon />
                        </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
        />
    </Stack>)
}


export default SearchBar